// Product page (phones): resize the photo slider to the photo showing,
// so taller photos aren't cropped and shorter ones leave no gap.
(function () {
  var mq = window.matchMedia('(max-width: 749px)');

  function setup(list) {
    var slides = function () {
      return Array.prototype.filter.call(list.children, function (li) {
        return li.offsetParent !== null && li.offsetWidth > 0;
      });
    };
    var ticking = false;

    function update() {
      ticking = false;
      if (!mq.matches) {
        list.style.height = '';
        return;
      }
      var items = slides();
      if (!items.length) return;
      var left = list.scrollLeft;
      var current = items[0];
      var best = Infinity;
      items.forEach(function (li) {
        var d = Math.abs(li.offsetLeft - list.offsetLeft - left);
        if (d < best) { best = d; current = li; }
      });
      var h = current.offsetHeight;
      if (h > 0) list.style.height = h + 'px';
    }

    function schedule() {
      if (!ticking) { ticking = true; setTimeout(update, 60); }
    }

    list.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    if (mq.addEventListener) mq.addEventListener('change', schedule);
    list.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', schedule);
    });
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(schedule);
      Array.prototype.forEach.call(list.children, function (li) { ro.observe(li); });
    }
    schedule();
  }

  function init() {
    document.querySelectorAll('.product__media-wrapper .product__media-list').forEach(function (list) {
      if (list.dataset.heightSync) return;
      list.dataset.heightSync = 'true';
      setup(list);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
